import { RouteLocationNormalized } from 'vue-router';

import { useAuthStore } from '@/stores/auth';

/* ------------------------------------------------------------
 * Redirect the root path after all access checks passed
 * ------------------------------------------------------------ */
export default function redirectRootGuard(to: RouteLocationNormalized) {
    const authStore = useAuthStore();
    if (to.path === '/' && authStore.isAuthenticated) {
        return { path: '/chat', query: to.query };
    }

    return true;
}
